<template lang="html"> </template>
<section v-if="value.affiliations">
  <div
    class="row content-padding"
    v-for="(affiliation, authorAffiliationIndex) in value.affiliations"
    v-bind:key="authorAffiliationIndex"
  >
    <!-- affiliation number and delete -->
    <div class="col-md-12">
      <div class="d-flex justify-content-between">
        <div>
          <h5>Affiliation {{ authorAffiliationIndex + 1 }}</h5>
        </div>
        <div>
          <p class="float-right mb-2">
            <a
              href="javascript:;"
              v-bind:class="{ deactive: disabled }"
              v-on:click="removeAuthorAffiliation(author, authorAffiliationIndex)"
            >
              <i class="fa fa-trash-alt"></i> Delete affiliation
            </a>
          </p>
        </div>
      </div>

      <hr />

      <label v-if="value.primary_contact">
        <input
          type="radio"
          v-bind:value="1"
          v-model="affiliation.corresp_aff"
          v-on:click="adjustCorrespAddress(value.affiliations, authorAffiliationIndex)"
          v-bind:class="{ deactive: disabled }"
        />
        <b>Corresponding address</b>
        <span class="radio"></span>
      </label>

      <small
        style="color: red;"
        v-if="hasError(index + '.affiliations')"
      >{{ hasError(index + '.affiliations', true) }}</small>

      <section class="affiliation">
        <p>
          <b>
            Select from the previously created affiliations to pre-populate the
            fields
          </b>
          <br />In the case that a previously created affiliation is selected to pre-populate a corresponding address, users will still be required to add the address and phone number manually.
        </p>
        <select class="form-control dropdown" v-bind:class="{ deactive: disabled }">
          <option disabled="disabled" selected="selected">Select Affiliation</option>
          <option
            v-for="(articleAffiliation, articleAffiliationIndex) in value.affiliations"
            v-bind:key="articleAffiliationIndex"
            v-bind:m="articleAffiliationIndex"
            v-bind:selected="value.affiliations[authorAffiliationIndex].aff_id == articleAffiliation.aff_id"
          >{{ returnAffiliationName(articleAffiliation) }}</option>
        </select>
      </section>
    </div>

    <!-- institution -->
    <div class="col-md-12">
      <h6>Institution or organization</h6>
      <small>Enter each element of the author affiliation in a separate field. Enter elements from largest to smallest.</small>
    </div>

    <!-- largest unit -->
    <div class="form-group col-md-12">
      <label v-bind:class="{ 'asterik': value.author_type == 'I' }">
        Largest unit (eg, university or organization)
        <jmir-popover position="right">
          <i class="fa fa-question-circle tooltip-target b3"></i>
          <template slot="content">
            <p>Each institution line will be separated by a comma and will (together with city and country) appear as affiliation footnote for each value. Please enter your affiliation(s) exactly as you want them to appear on the title page of the paper. Do not use ALL CAPS or all lower case. We recommend to use title case (e.g. Department of Health Policy, Management, and Evaluation), and no acronyms or abbreviations (e.g. "Department" instead of "Dept.")</p>
          </template>
        </jmir-popover>
      </label>
      <input
        v-bind:id="'' + 'largest unit of author ' + (index + 1) + ' ' + 'affiliation ' + (authorAffiliationIndex + 1) + ''"
        type="text"
        class="form-control"
        v-model="affiliation.address.institution_line_1"
        v-bind:name="'largest unit of author ' + (index + 1) + ' ' + 'affiliation ' + (authorAffiliationIndex + 1) + ''"
        v-validate="(value.author_type == 'I') ? 'required' : ''"
        v-bind:class="{
    'deactive': disabled,
    'form-error': hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' +  'address.institution_line_1'),
    'input-outline-error': $validator.errors.first('largest unit of author ' + (index + 1) + ' ' + 'affiliation ' + (authorAffiliationIndex + 1))
    }"
        @input="removeAffId(affiliation)"
      />
      <span
        class="text-error"
      >{{ $validator.errors.first('largest unit of author ' + (index + 1)+ ' ' + 'affiliation ' + (authorAffiliationIndex + 1)) }}</span>
      <small
        style="color: red;;"
        v-if="hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.institution_line_1')"
      >{{ hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.institution_line_1', true) }}</small>
    </div>

    <!-- smaller unit -->
    <div class="form-group col-md-12">
      <label>Smaller unit (eg, department or division)</label>
      <input
        type="text"
        class="form-control"
        v-model="affiliation.address.institution_line_2"
        v-bind:class="{ 'deactive': disabled, 'form-error': hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.institution_line_2') }"
        @input="removeAffId(affiliation)"
      />
      <small
        style="color: red;;"
        v-if="hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.institution_line_2')"
      >{{ hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.institution_line_2', true) }}</small>
    </div>

    <div class="form-group col-md-12">
      <label>Smallest unit (eg, research team)</label>
      <input
        type="text"
        class="form-control"
        v-model="affiliation.address.institution_line_3"
        v-bind:class="{ deactive: disabled }"
      />
    </div>

    <!-- add additional unit -->
    <div class="form-group col-md-12">
      <div
        v-for="(subfield, subfieldIndex) in affiliation.address.institution_line_4"
        v-bind:key="subfieldIndex"
      >
        <label>Additional unit</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-bind:name="'field' + index + ''"
            :ref="'subfield-' + index + '-' + subfieldIndex"
            v-model="subfield.value"
            v-bind:class="{ 'deactive': disabled, 'form-error': hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.institution_line_3') }"
            v-on:input="removeAffId(affiliation)"
          />
          <!-- </label> -->
          <div class="input-group-append">
            <button
              href="javascript:;"
              class="btn-custom btn-custom-grey"
              v-on:click="removeSubfield(index, authorAffiliationIndex, subfieldIndex)"
              v-bind:class="{ deactive: disabled }"
            >
              <i class="fa fa-trash-alt" style="color: #555555;"></i>
            </button>
          </div>
        </div>
      </div>
      <small
        style="color: red;"
        v-if="hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.institution_line_3')"
      >{{ hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.institution_line_3', true) }}</small>
    </div>

    <!-- add another field -->
    <div class="form-group col-md-12">
      <a
        class="subfield"
        v-on:click="addSubfieldAffiliation(affiliation.address.institution_line_4)"
      >
        <i class="fa fa-plus"></i> Add another field
      </a>
    </div>

    <!-- address line 1 -->
    <div
      class="form-group col-md-6"
      v-if="affiliation.corresp_aff && value.primary_contact"
    >
      <label class="asterik">Address line 1</label>
      <input
        v-bind:id="'' + 'address line 1' + ''"
        type="text"
        class="form-control"
        required="required"
        v-model="affiliation.address.address_line_1"
        name="address line 1"
        v-validate="'required'"
        v-bind:class="{ 'deactive': disabled, 'form-error': hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.address_line_1'),
    'input-outline-error': $validator.errors.first('address line 1')
    }"
        @input="removeAffId(affiliation)"
      />
      <span class="text-error">{{ $validator.errors.first('address line 1') }}</span>
      <small
        style="color: red;"
        v-if="hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.address_line_1')"
      >{{ hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.address_line_1', true) }}</small>
    </div>

    <!-- address line 2 -->
    <div
      class="form-group col-md-6"
      v-if="affiliation.corresp_aff && value.primary_contact"
    >
      <label>Address line 2</label>
      <input
        type="text"
        class="form-control"
        v-model="affiliation.address.address_line_2"
        @input="removeAffId(affiliation)"
        v-bind:class="{ deactive: disabled }"
      />
    </div>

    <!-- city -->
    <div class="form-group col-md-6">
      <label v-bind:class="{ 'asterik': value.author_type == 'I' }">City</label>
      <input
        v-bind:id="'' + 'city of author ' + (index + 1) + ' ' + 'affiliation ' +(authorAffiliationIndex + 1) + ''"
        type="text"
        class="form-control"
        v-bind:name="'city of author ' + (index + 1) + ' ' + 'affiliation ' +(authorAffiliationIndex + 1) + ''"
        v-validate="(value.author_type == 'I') ? 'required' : ''"
        v-model="affiliation.address.city"
        v-bind:class="{
    'deactive': disabled, 'form-error': hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex  + '.' + 'address.city'),
    'input-outline-error': $validator.errors.first('city of author ' + (index + 1) + ' ' + 'affiliation ' + (authorAffiliationIndex + 1))
    }"
        @input="removeAffId(affiliation)"
      />
      <span
        class="text-error"
      >{{ $validator.errors.first('city of author ' + (index + 1)+ ' ' + 'affiliation ' + (authorAffiliationIndex + 1)) }}</span>
      <small
        style="color: red;"
        v-if="hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.city')"
      >{{ hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.city', true) }}</small>
    </div>

    <!-- country -->
    <div class="form-group col-md-6">
      <label v-bind:class="{ 'asterik': value.author_type == 'I' }">Country</label>
      <div>
        <jselect
          :options="countries"
          :label="country"
          :key="name"
          :disabled="disabled"
          :default-option="true"
          v-model="affiliation.address.country"
        ></jselect>
      </div>
      <span
        class="text-error"
      >{{ $validator.errors.first('country of author ' + (index + 1)+ ' ' + 'affiliation ' + (authorAffiliationIndex + 1)) }}</span>
      <small
        style="color: red;"
        v-if="hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.country')"
      >{{ hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.country', true) }}</small>
    </div>

    <!-- state/ province -->
    <div class="form-group col-md-6">
      <div
        v-if="affiliation.address.country != null && (affiliation.address.country.iso == 'CA' || affiliation.address.country.iso == 'US')"
      >
        <label
          v-bind:class="{ 'asterik': value.author_type == 'I' }"
        >{{ affiliation.address.country.iso == 'CA' ? 'Province' : 'State' }}</label>

        <div>
          <select
            v-bind:id="'' + 'province / state of author ' + (index + 1) + ' ' + 'affiliation ' +(authorAffiliationIndex + 1) + ''"
            class="form-control"
            v-bind:class="{
        'deactive': disabled, 'form-error': hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.prov_state'),
        'input-outline-error': $validator.errors.first('province / state of author ' + (index + 1) + ' ' + 'affiliation ' + (authorAffiliationIndex + 1))
        }"
            v-model="affiliation.address.prov_state"
            v-bind:name="'province / state of author ' + (index + 1) + ' ' + 'affiliation ' +(authorAffiliationIndex + 1) + ''"
            v-validate="(value.author_type == 'I') ? 'required' : ''"
          >
            <option
              value
            >Please select a {{ affiliation.address.country.iso == 'CA' ? 'province' : 'state' }}</option>
            <option
              v-for="(province, index) in affiliation.address.country.provinces"
              v-bind:key="index"
              v-bind:value="province.code"
            >{{ province.name }}</option>
          </select>
        </div>
      </div>
      <div v-else>
        <label v-bind:class="{ 'asterik': value.author_type == 'I' }">Province / State</label>

        <input
          v-bind:id="'province / state of author ' + (index + 1) + ' ' + 'affiliation ' +(authorAffiliationIndex + 1) + ''"
          type="text"
          class="form-control"
          v-model="affiliation.address.prov_state"
          v-bind:class="{
        'deactive': disabled, 'form-error': hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.prov_state'),
        'input-outline-error': $validator.errors.first('province / state of author ' + (index + 1) + ' ' + 'affiliation ' + (authorAffiliationIndex + 1))
    }"
          @input="removeAffId(affiliation)"
          v-bind:name="'province / state of author ' + (index + 1) + ' ' + 'affiliation ' +(authorAffiliationIndex + 1) + ''"
          v-validate="(value.author_type == 'I') ? 'required' : ''"
        />
      </div>
      <span
        class="text-error"
      >{{ $validator.errors.first('province / state of author ' + (index + 1)+ ' ' + 'affiliation ' + (authorAffiliationIndex + 1)) }}</span>
      <small
        style="color: red;"
        v-if="hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.prov_state')"
      >{{ hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'address.prov_state', true) }}</small>
    </div>

    <!-- zip/ postal code -->
    <div class="form-group col-md-6">
      <template v-if="affiliation.corresp_aff && value.primary_contact">
        <div class="form-group">
          <label>Zip/ postal code</label>
          <input
            type="text"
            class="form-control"
            v-model="affiliation.address.postal_code"
            @input="removeAffId(affiliation)"
            v-bind:class="{ deactive: disabled }"
          />
        </div>
      </template>
    </div>

    <!-- phone -->
    <template v-if="affiliation.corresp_aff && value.primary_contact">
      <div class="form-group col-md-4">
        <label class="asterik">Phone number</label>
        <br />
        <select
          v-bind:id="'' + 'country code' + ''"
          class="col-md-2 col-sm-2 col-xs-2 form-control phone-code-width"
          v-model="affiliation.phone_code"
          name="country code"
          v-validate="'required'"
          v-bind:class="{ 'deactive': disabled, 'input-outline-error': $validator.errors.first('country code') }"
        >
          <option
            v-for="(countryCode, index) in countryCodes"
            v-bind:value="countryCode.phonecode"
            v-bind:key="index"
          >{{ countryCode.phonecode }}</option>
        </select>
        <input
          v-bind:id="'' + 'phone number' + ''"
          type="text"
          class="ml-2 form-control col-md-8 col-sm-10 col-xs-10 col-md-offset-1 phone-width"
          required="required"
          v-model="affiliation.phone.phone"
          name="phone number"
          v-validate="'required'"
          v-bind:class="{
        'deactive': disabled, 'form-error': hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'phone'),
        'input-outline-error': $validator.errors.first('phone number')
    }"
          @input="removeAffId(affiliation)"
        />
        <div class="col-md-12">
          <span class="text-error">{{ $validator.errors.first('country code') }}</span>
        </div>
        <div class="col-md-12">
          <span class="text-error">{{ $validator.errors.first('phone number') }}</span>
        </div>

        <small
          style="color: red;"
          v-if="hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'phone')"
        >{{ hasError(index + '.' + 'affiliations' + '.' + authorAffiliationIndex + '.' + 'phone', true) }}</small>
      </div>
      <div class="form-group col-md-4">
        <label>Extension</label>
        <input
          type="text"
          class="form-control"
          v-model="affiliation.extension"
          v-bind:class="{ deactive: disabled }"
        />
      </div>
      <div class="form-group col-md-4">
        <label>Fax number</label>
        <input
          type="text"
          class="form-control"
          v-model="affiliation.fax"
          v-bind:class="{ deactive: disabled }"
        />
      </div>
    </template>
  </div>
</section>
<script>
export default {
  props: ["article"],
  methods: {
    hasError: () => {}
  }
};
</script>

<style lang="css" scoped></style>
